import { render, staticRenderFns } from "./AdvisorAnalytics.vue?vue&type=template&id=b3246efc&scoped=true"
import script from "./AdvisorAnalytics.vue?vue&type=script&lang=js"
export * from "./AdvisorAnalytics.vue?vue&type=script&lang=js"
import style0 from "./AdvisorAnalytics.vue?vue&type=style&index=0&id=b3246efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3246efc",
  null
  
)

export default component.exports